// "use client"
//? Library Imports ------------------------------------------------------------>
import {
  Col,
  Row,
  Form,
  Spin,
  Radio,
  Space,
  message,
  Checkbox,
  Typography,
} from "antd";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Button, TextField, Autocomplete } from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

//? Modules -------------------------------------------------------------------->
import SaveAddressModel from "../SaveAddressModel/SaveAddressModel";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import "./index.css";

//? Assets --------------------------------------------------------------------->
import { ArrowLeftOutlined } from "@ant-design/icons";
import { createTheme, ThemeProvider } from "@mui/material/styles";

//? Redux Reducers ------------------------------------------------------------->
import AccountStatus from "@/functions/Cookies/Cookies";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

var primary_red = "#ff0d50";

const theme = createTheme({
  palette: {
    primary: {
      main: primary_red,
    },
  },
});

export default function CreateNewAddress({
  FormType,
  setFormType,
  SelectedAddress,
  setAddNewAddress,
  fetchCustomerAddresses,
}) {
  const userAgent = {};
  const [createAddress] = Form.useForm();

  //? Redux States --------------------------------------------------------------->
  const [SelectedTag, setSelectedTag] = useState(
    useSelector((state) => state.accountSlice.comverse_customer_tags[0])
  );
  const [AddressTagList, setAddressTagList] = useState(
    useSelector((state) => state?.accountSlice?.comverse_customer_tags)
  );

  //? Hooks ---------------------------------------------------------------------->
  const { isDesktop } = userAgent;
  const { loggedIn, comverse_customer_email, comverse_customer_token } =
    AccountStatus();

  //? States --------------------------------------------------------------------->
  const [buttonDisableCheckout, setbuttonDisableCheckout] = useState(true);
  const [countryCode, setCountryCode] = useState("pk");
  const [showPostalCode, setShowPostalCode] = useState(true);
  const [phoneErrorState, setPhoneErrorState] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [TagsList, setTagsList] = useState([]);
  const [CitiesList, setCitiesList] = useState([]);
  // const [CountryCodes, setCountryCodes] = useState([]);
  const [hideStateDropdown, setHideStateDropdown] = useState(false);
  const [ProvincesList, setProvincesList] = useState([]);
  const [CountriesList, setCountriesList] = useState([]);
  // const [AvailableCountries, setAvailableCountries] = useState([]);
  const [autoCompleteCountryValue, setAutoCompleteCountryValue] =
    useState(null);
  const [autoCompleteStateValue, setAutoCompleteStateValue] = useState(null);
  const [autoCompleteCityValue, setAutoCompleteCityValue] = useState(null);

  const [HasErrors, setHasErrors] = useState(
    FormType === "edit" ? false : true
  );
  const [FormData, setFormData] = useState({
    fullName: FormType === "edit" ? SelectedAddress?.full_name : "",
    email: loggedIn ? comverse_customer_email : SelectedAddress?.email || "",
    phoneNo: FormType === "edit" ? SelectedAddress?.phone : "",
    address: FormType === "edit" ? SelectedAddress?.address : "",
    country: FormType === "edit" ? SelectedAddress?.country : "",
    country_flag: FormType === "edit" ? SelectedAddress?.country_flag : "",
    province: FormType === "edit" ? SelectedAddress?.province : "",
    city: FormType === "edit" ? SelectedAddress?.city : "",
    zipCode: FormType === "edit" ? SelectedAddress?.postal_code : "",
  });

  const [autoCompleteFieldValues, setautoCompleteFieldValues] = useState({
    country: FormType === "edit" ? SelectedAddress?.country : "",
    province: FormType === "edit" ? SelectedAddress?.province : "",
    city: FormType === "edit" ? SelectedAddress?.city : "",
  });

  //? Save Address Modal States -------------------------------------------------->
  const [ShowModal, setShowModal] = useState(false);
  const [DefaultAddress, setDefaultAddress] = useState(false);

  //? Functions ------------------------------------------------------------------>
  const fetchCities = async (provinceId) => {
    if (provinceId) {
      try {
        setLoading(true);
        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
          "/order/cities?state_id=" +
          provinceId
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error("CitiesList Api Failed!");
        } else {
          if (data?.length > 0) {
            const citiesList = data?.map((state) => {
              return {
                id: state?.id,
                value: state?.name,
                label: state?.name,
              };
            });

            setCitiesList(data);

            setLoading(false);
          } else {
            setCitiesList([]);

            FormData.city = "";
            setFormData({ ...FormData });

            setLoading(false);
          }
        }
      } catch (error) {
        console.log("CitiesList Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }
  };
  useEffect(() => {
    fetchCities(1089);
  }, []);

  const fetchProvinces = async (country) => {
    if (country?.key) {
      try {
        setLoading(true);
        const ProvincesList = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
          `/order/states?country_id=${country?.key}`
        );
        const ProvincesResponse = await ProvincesList.json();

        if (!ProvincesList.ok) {
          throw new Error("Api Failed!");
        } else {
          if (ProvincesResponse?.length > 0) {
            if (
              ProvincesResponse?.length > 0 &&
              ProvincesResponse[0]?.name === "All State"
            ) {
              setLoading(true);
              FormData.province = ProvincesResponse[0]?.name;
              FormData.zipCode = "1111";
              setFormData({ ...FormData });
              setAutoCompleteStateValue(ProvincesResponse[0]);
              fetchCities(ProvincesResponse[0]?.id);
              setHideStateDropdown(true);
            } else {
              setHideStateDropdown(false);
              setProvincesList(ProvincesResponse);
            }
            // (FormData.province = ProvincesResponse[0]?.name),
            //   setFormData({ ...FormData });

            // fetchCities(ProvincesResponse[0]?.id);
            if (ProvincesResponse[0]?.name !== "All State") {
              setLoading(false);
            }
          } else {
            fetchCities(1089);
            setProvincesList([]);
            setCitiesList([]);

            // (FormData.province = ""),
            //   (FormData.city = ""),
            //   setFormData({ ...FormData });

            setLoading(false);
          }
        }
      } catch (error) {
        console.log("error", error);

        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }
  };

  const fetchCountries = async () => {
    if (loggedIn && comverse_customer_token) {
      try {
        setLoading(true);
        const headers = {
          "Content-Type": "application/json",
          Authorization: comverse_customer_token,
        };

        const payload = {
          method: "GET",
          headers: headers,
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
          "/storefront/countries?storefront=23",
          payload
        );
        const data = await res.json();

        if (!res.ok) {
          throw new Error("CountriesList Api Failed!");
        } else {
          setCountriesList(data);

          // if (data?.length > 0) {
          //   setAvailableCountries(
          //     data?.map((country) => country?.value?.toLowerCase())
          //   );

          //   // setCountryCodes(data?.map((country) => country?.flag));
          // }

          if (!SelectedAddress?.country && data?.length > 0) {
            FormData.country = data[0]?.text;
            FormData.country_flag = data[0]?.flag;
            setFormData({ ...FormData });

            // fetchProvinces(data[0]);
            setLoading(false);
          } else if (data?.length > 0) {
            let country = data?.find(
              (country) => country?.text === SelectedAddress?.country
            );

            if (country) {
              FormData.country = country?.text || "";
              FormData.country_flag = country?.flag || "";

              if (country?.text === SelectedAddress?.country) {
                FormData.phoneNo = SelectedAddress?.phone;
              }

              setFormData({ ...FormData });
            }
            setLoading(false);
          }
        }
      } catch (error) {
        console.log("CountriesList Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }
  };

  const createCustomerAddress = async (event) => {
    event.preventDefault();
    if (FormData?.phoneNo?.length > 7) {
      setPhoneErrorState(false);
      setHasErrors(false);
    } else {
      setPhoneErrorState(true);
      setHasErrors(true);
    }
    if (
      comverse_customer_token &&
      !HasErrors &&
      !phoneErrorState &&
      !buttonDisableCheckout
    ) {
      try {
        const body = {
          full_name: FormData?.fullName,
          phone: FormData?.phoneNo,
          postal_code:
            FormData?.country === "Pakistan" ||
              FormData?.country === "United Arab Emirates"
              ? "1111"
              : FormData?.zipCode,
          country: FormData?.country,
          province:
            FormData?.country === "Pakistan"
              ? "All State"
              : ProvincesList?.length > 0
                ? FormData?.province
                : autoCompleteFieldValues?.province,
          city:
            CitiesList.length === 0
              ? autoCompleteFieldValues?.city
              : FormData?.city,
          address: FormData?.address,
          primary_address: DefaultAddress,
          tag: SelectedTag,
        };

        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "POST",
          headers: headers,
          body: JSON.stringify(body),
        };
        const CreateCustomer = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + "/storefront/customer_address",
          payload
        );

        const CustomerAddress = await CreateCustomer.json();

        if (!CreateCustomer.ok) {
          CustomerAddress?.detail && message.error(CustomerAddress.detail);
          throw new Error("CreateCustomer Api Failed!");
        } else {
          message.success(CustomerAddress.detail);
          setAddNewAddress(false);
          fetchCustomerAddresses();
          return CustomerAddress;
        }
      } catch (error) {
        console.log("CreateCustomer Api Failed!", error);
      }
    } else {
      if (phoneErrorState) {
        message.error("Phone format not correct.");
      } else {
        message.error("Invalid Details!");
      }
      if (buttonDisableCheckout) {
        message.error("Please select correct details.");
      }
      const body = {
        id: SelectedAddress?.id,
        full_name: FormData?.fullName,
        phone: FormData?.phoneNo,
        postal_code: FormData?.zipCode,
        country: FormData?.country,
        province: FormData?.province,
        city: FormData?.city,
        address: FormData?.address,
        primary_address: DefaultAddress,
        tag: SelectedTag,
      };
    }
  };

  const updateCustomerAddress = async (event) => {
    event.preventDefault();

    if (FormData?.phoneNo?.length > 7) {
      setPhoneErrorState(false);
      setHasErrors(false);
    } else {
      setPhoneErrorState(true);
      setHasErrors(true);
    }

    if (
      comverse_customer_token &&
      !HasErrors &&
      !phoneErrorState &&
      !buttonDisableCheckout
    ) {
      try {
        const body = {
          id: SelectedAddress?.id,
          full_name: FormData?.fullName,
          phone: FormData?.phoneNo,
          postal_code:
            FormData?.country === "Pakistan" ||
              FormData?.country === "United Arab Emirates"
              ? "1111"
              : FormData?.zipCode,
          country: FormData?.country,
          province:
            FormData?.country === "Pakistan"
              ? "All State"
              : ProvincesList?.length > 0
                ? FormData?.province
                : autoCompleteFieldValues?.province,
          city:
            CitiesList.length === 0
              ? autoCompleteFieldValues?.city
              : FormData?.city,
          address: FormData?.address,
          primary_address: DefaultAddress,
          tag: SelectedTag,
        };

        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "PUT",
          headers: headers,
          body: JSON.stringify(body),
        };
        const CreateCustomer = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + "/storefront/customer_address",
          payload
        );

        const CustomerAddress = await CreateCustomer.json();

        if (!CreateCustomer.ok) {
          CustomerAddress?.detail && message.error(CustomerAddress.detail);
          throw new Error("CreateCustomer Api Failed!");
        } else {
          message.success(CustomerAddress?.detail);
          setFormType("create");
          setAddNewAddress(false);
          fetchCustomerAddresses();
        }

        return CustomerAddress;
      } catch (error) {
        console.log("CreateCustomer Api Failed!", error);
      }
    } else {
      if (phoneErrorState) {
        message.error("Phone format not correct.");
      } else {
        message.error("Invalid Details!");
      }
      if (buttonDisableCheckout) {
        message.error("Please select correct details.");
      }
      const body = {
        id: SelectedAddress?.id,
        full_name: FormData?.fullName,
        phone: FormData?.phoneNo,
        postal_code: FormData?.zipCode,
        country: FormData?.country,
        province:
          ProvincesList.length === 0
            ? autoCompleteFieldValues?.province
            : FormData?.province,
        city:
          CitiesList.length === 0
            ? autoCompleteFieldValues?.city
            : FormData?.city,
        address: FormData?.address,
        primary_address: DefaultAddress,
        tag: SelectedTag,
      };

      console.log(body);
    }
  };

  const changeDefaultAddress = (e) => {
    setDefaultAddress(e.target.checked);
  };

  const changeSelectedTag = (e) => {
    setSelectedTag(e.target.value);
  };

  const fetchTagsList = useCallback(async () => {
    if (comverse_customer_token) {
      try {
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "GET",
          headers: headers,
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + "/storefront/tags",
          payload
        );
        const data = await res.json();

        if (!res.ok) {
          throw new Error("Api Failed!");
        } else {
          setTagsList(data);
          setSelectedTag(data[0]);
          return data;
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
        return null;
      }
    }
  }, [comverse_customer_token]);

  const getCustomerCityDropDown = (cityName) => {
    CitiesList.map((item) => {
      if (item?.name?.toLowerCase() === cityName.toLowerCase()) {
        setAutoCompleteCityValue(item);
      }
    });
  };

  const getCustomerProvinceDropDown = (provinceName) => {
    ProvincesList.map((item) => {
      if (item?.name?.toLowerCase() === provinceName?.toLowerCase()) {
        setAutoCompleteStateValue(item);
        fetchCities(item?.id);
        // getCustomerCityDropDown(FormData?.city);
      }
    });
  };

  const getCustomerCountryDropDown = (countryName) => {
    CountriesList.map((item) => {
      if (countryName?.toLowerCase() === item?.text?.toLowerCase()) {
        setAutoCompleteCountryValue(item);
        fetchProvinces(item);
        // getCustomerProvinceDropDown(FormData?.province);
      }
    });
  };

  useEffect(() => {
    if (FormType === "edit") {
      let country = FormData?.country;
      getCustomerCountryDropDown(country);
    }
  }, [CountriesList]);

  useEffect(() => {
    if (FormType === "edit") {
      let province = FormData?.province;
      getCustomerProvinceDropDown(province);
    }
  }, [autoCompleteCountryValue, ProvincesList]);

  useEffect(() => {
    if (FormType === "edit") {
      let city = FormData?.city;
      getCustomerCityDropDown(city);
    }
  }, [autoCompleteStateValue, CitiesList]);

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (comverse_customer_token) {
      fetchTagsList();
    }
  }, [comverse_customer_token, fetchTagsList]);

  useEffect(() => {
    return () => {
      setFormType("create");
    };
  }, [setFormType]);

  useEffect(() => { }, [FormData]);

  useEffect(() => {
    if (FormData?.phoneNo?.length > 7) {
      setPhoneErrorState(false);
      setHasErrors(false);
    } else {
      setPhoneErrorState(true);
      setHasErrors(true);
    }
  }, [FormData.phoneNo]);

  useEffect(() => {
    if (
      FormData?.country === "Pakistan" ||
      FormData?.country === "United Arab Emirates"
    ) {
      setShowPostalCode(false);
      setFormData({
        ...FormData,
        zipCode: "1111",
      });
    } else {
      setShowPostalCode(true);
      setFormData({
        ...FormData,
        zipCode: "",
      });
    }
  }, [FormData?.country]);

  useEffect(() => {
    let countryCodeOld = countryCode;
    if (FormData?.phoneNo === "") {
      setCountryCode("us");
      setTimeout(() => {
        setCountryCode(countryCodeOld);
      }, 200);
    }
  }, [FormData?.phoneNo]);

  useEffect(() => {
    if (FormData?.country === "Pakistan" && CitiesList?.length === 0) {
      setbuttonDisableCheckout(true);
    } else if (FormData?.country === "Pakistan" && CitiesList?.length > 0) {
      setbuttonDisableCheckout(false);
    } else {
      setbuttonDisableCheckout(false);
    }
  }, [FormData?.country, CitiesList]);

  return (
    <Col>
      <Col className="flexBetween marginBottom20">
        <Space size="middle">
          <Col
            style={{
              background: "#FFFFFF",
              width: "29px",
              height: "30px",
            }}
            className="flexCenter cursorPointer"
            onClick={() => setAddNewAddress(false)}
          >
            <ArrowLeftOutlined />
          </Col>
          <Text className="font18">Create New Address</Text>
        </Space>

        <Space>
          {/* <DynamicButton
            name="Save"
            className="addBtn"
            function={() => createAddress.submit()}
          /> */}

          <Button
            type="submit"
            disableElevation
            variant="contained"
            form="userInformationForm"
            className="addBtn"
            style={{
              // width: "100%",
              // height: "44px",
              // fontWeight: 600,
              // fontSize: "16px",
              // borderRadius: "6px",
              textTransform: "capitalize",
            }}
          >
            Save
          </Button>

          <DynamicButton
            name="Cancel"
            className="editBtn"
            function={() => setAddNewAddress(false)}
          />
        </Space>
      </Col>

      <Col span={14}>
        <Row className="UserDetailsSection">
          <Col span={24}>
            <Spin spinning={Loading} delay={500}>
              <ThemeProvider theme={theme}>
                <form
                  id="userInformationForm"
                  onSubmit={
                    FormType === "create"
                      ? createCustomerAddress
                      : updateCustomerAddress
                  }
                  className="InformationForm marginTop15"
                >
                  <TextField
                    required
                    fullWidth
                    type="text"
                    size="small"
                    name="fullName"
                    margin="normal"
                    label="Full Name"
                    variant="outlined"
                    value={FormData?.fullName}
                    onChange={(e) => {
                      setFormData({
                        ...FormData,
                        fullName: e.target.value,
                      });
                    }}
                  />

                  <TextField
                    required
                    fullWidth
                    type="email"
                    size="small"
                    name="email"
                    label="Email"
                    margin="normal"
                    variant="outlined"
                    disabled={loggedIn}
                    value={FormData?.email}
                    onChange={(e) => {
                      setFormData({
                        ...FormData,
                        email: e.target.value,
                      });
                    }}
                  />
                  <TextField
                    required
                    fullWidth
                    type="text"
                    size="small"
                    name="country"
                    margin="normal"
                    label="Country"
                    variant="outlined"
                    value="Pakistan"
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      readOnly: true,
                    }}
                  />

                  {/* <Autocomplete
                    size="small"
                    name="country"
                    margin="normal"
                    aria-required="true"
                    value={autoCompleteCountryValue}
                    options={CountriesList}
                    getOptionLabel={(option) => option.text}
                    onChange={(e, newValue) => {
                      setHideStateDropdown(false);
                      setAutoCompleteStateValue(null);
                      setAutoCompleteCityValue(null);
                      let selectedCountry = null;

                      if (newValue) {
                        selectedCountry = CountriesList?.find(
                          (country) => country?.text === newValue.text
                        );
                      } else {
                        setAutoCompleteCountryValue(null);
                        setProvincesList([]);
                        setCitiesList([]);
                        setAutoCompleteStateValue(null);
                        autoCompleteFieldValues.city = "";
                        autoCompleteFieldValues.province = "";
                        setautoCompleteFieldValues({
                          ...autoCompleteFieldValues,
                        });
                      }
                      if (selectedCountry) {
                        FormData.phoneNo = "";
                        setAutoCompleteCountryValue(selectedCountry);
                        if (selectedCountry?.text === "Pakistan") {
                          setLoading(true);
                        }
                        setCountryCode((selectedCountry?.flag).toLowerCase());
                        FormData.country = newValue.text;
                        fetchProvinces(selectedCountry);
                      } else {
                        FormData.country = "";
                        setAutoCompleteCountryValue(null);
                        setAutoCompleteStateValue(null);
                      }
                      FormData.province = "";
                      FormData.city = "";
                      FormData.address = "";
                      setFormData({ ...FormData });
                    }}
                    renderInput={(params) => (
                      <TextField
                        required
                        {...params}
                        name="country"
                        label="Country"
                        margin="normal"
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password",
                        }}
                      />
                    )}
                  /> */}
                  {/* 
                  {ProvincesList?.length > 0 && !hideStateDropdown ? (
                    <Autocomplete
                      size="small"
                      name="province"
                      margin="normal"
                      label="Province/State"
                      value={autoCompleteStateValue}
                      options={ProvincesList}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, newValue) => {
                        setAutoCompleteCityValue(null);
                        let selectedProvince = null;

                        if (newValue) {
                          selectedProvince = ProvincesList?.find(
                            (province) => province?.name === newValue?.name
                          );
                        } else {
                          setCitiesList([]);
                          FormData.province = "";
                          FormData.city = "";
                          setFormData({ ...FormData });
                          autoCompleteFieldValues.city = "";
                          setautoCompleteFieldValues({
                            ...autoCompleteFieldValues,
                          });
                        }
                        if (selectedProvince) {
                          FormData.province = newValue?.name;
                          FormData.city = "";
                          FormData.address = "";
                          setFormData({ ...FormData });
                          fetchCities(selectedProvince?.id);
                          setAutoCompleteStateValue(newValue);
                        } else {
                          FormData.province = "";
                          setAutoCompleteStateValue(null);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          name="province"
                          margin="normal"
                          variant="outlined"
                          label="Province/State"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password",
                          }}
                        />
                      )}
                    />
                  ) : (
                    !hideStateDropdown && (
                      <TextField
                        required
                        fullWidth
                        type="text"
                        size="small"
                        margin="normal"
                        name="province"
                        variant="outlined"
                        label="State/Province"
                        value={autoCompleteFieldValues?.province}
                        onChange={(e) => {
                          (FormData.province = e.target.value),
                            setFormData({ ...FormData });
                          (autoCompleteFieldValues.province = e.target.value),
                            setautoCompleteFieldValues({
                              ...autoCompleteFieldValues,
                            });
                        }}
                      />
                    )
                  )} */}

                  {CitiesList?.length > 0 ? (
                    <Autocomplete
                      size="small"
                      name="city"
                      label="City"
                      margin="normal"
                      value={autoCompleteCityValue}
                      options={CitiesList}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, newValue) => {
                        if (newValue) {
                          FormData.city = newValue?.name;
                          setAutoCompleteCityValue(newValue);
                          setFormData({ ...FormData });
                        } else {
                          setAutoCompleteCityValue(null);
                          FormData.city = "";
                          setFormData({ ...FormData });
                          autoCompleteFieldValues.city = "";
                          setautoCompleteFieldValues({
                            ...autoCompleteFieldValues,
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          name="city"
                          label="City"
                          margin="normal"
                          variant="outlined"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password",
                          }}
                        />
                      )}
                    />
                  ) : (
                    <TextField
                      required
                      fullWidth
                      type="text"
                      name="city"
                      label="City"
                      size="small"
                      margin="normal"
                      variant="outlined"
                      value={autoCompleteFieldValues?.city}
                      onChange={(e) => {
                        (FormData.city = e.target.value),
                          setFormData({ ...FormData });
                        (autoCompleteFieldValues.city = e.target.value),
                          setautoCompleteFieldValues({
                            ...autoCompleteFieldValues,
                          });
                      }}
                    />
                  )}

                  <div className="telephone-field">
                    <PhoneInput
                      disableDropdown
                      countryCodeEditable={false}
                      required
                      name="phoneNo"
                      value={FormData?.phoneNo}
                      country={countryCode}
                      // autoFormat={false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        required: true,
                        maxLength:
                          countryCode === "pk" ||
                            FormData?.country?.toLowerCase() === "pakistan"
                            ? 15
                            : 20,
                        minLength:
                          countryCode === "pk" ||
                            FormData?.country?.toLowerCase() === "pakistan"
                            ? 15
                            : 7,
                      }}
                      onChange={(value, country, e, formattedValue) => {
                        if (value) {
                          setPhoneErrorState(false);
                          setHasErrors(false);
                          setFormData({
                            ...FormData,
                            phoneNo: "+" + value,
                          });
                        }
                      }}
                      onCountryChange={() => { }}
                    />
                    {/* <PhoneInput
                      disableDropdown
                      countryCodeEditable={false}
                      required
                      name="phoneNo"
                      value={FormData?.phoneNo}
                      country="pk"
                      inputProps={{
                        required: true,
                        maxLength: 15,
                        minLength: 7,
                      }}
                      onChange={(value) => {
                        setPhoneErrorState(false);
                        setFormData({ ...FormData, phoneNo: "+" + value });
                      }}
                    /> */}

                    {/* {phoneErrorState && (
                      <Text className="phone-format-error">
                        Phone format is not correct
                      </Text>
                    )} */}
                  </div>

                  <TextField
                    required
                    fullWidth
                    type="text"
                    size="small"
                    name="address"
                    margin="normal"
                    label="Address"
                    variant="outlined"
                    value={FormData?.address}
                    onChange={(e) => {
                      setFormData({
                        ...FormData,
                        address: e.target.value,
                      });
                    }}
                  />
                  {showPostalCode && (
                    <TextField
                      required
                      fullWidth
                      type="text"
                      size="small"
                      name="zipCode"
                      margin="normal"
                      label="Postal Code"
                      variant="outlined"
                      value={FormData?.zipCode}
                      onChange={(e) => {
                        setFormData({
                          ...FormData,
                          zipCode: e.target.value,
                        });
                      }}
                    />
                  )}
                </form>
              </ThemeProvider>
            </Spin>
          </Col>

          {loggedIn && comverse_customer_token ? (
            <Col span={24} className="marginTop15">
              <Space direction="vertical" className="width100">
                <Text
                  style={{
                    color: "#000000",
                    letterSpacing: "0px",
                  }}
                  className={!isDesktop ? "font14Bold" : "font16Bold"}
                >
                  Save Address As
                </Text>
                <Space>
                  <Radio.Group
                    className="addressTags"
                    defaultValue={SelectedTag}
                    onChange={changeSelectedTag}
                  >
                    {TagsList?.map((tag, index) => {
                      const length = TagsList?.length;

                      return (
                        <>
                          <Radio.Button
                            style={{ borderColor: "#d9d9d9" }}
                            value={tag}
                            key={index}
                            className={!isDesktop ? "font12" : "tag"}
                          >
                            {tag}
                          </Radio.Button>
                          {/* {length === index + 1 && index < 4 ? (
                            <div
                              style={{
                                width: "30px",
                                height: "30px",
                                color: "black",
                                background: "#E2E5F1",
                              }}
                              onClick={() => setShowModal(!ShowModal)}
                              className="circle borderRadius25 flexCenter cursorPointer"
                            >
                              <Text>+</Text>
                            </div>
                          ) : null} */}
                        </>
                      );
                    })}
                  </Radio.Group>
                </Space>
                <Checkbox
                  checked={DefaultAddress}
                  onChange={(e) => changeDefaultAddress(e)}
                >
                  Save Address as Default
                </Checkbox>
              </Space>

              <SaveAddressModel
                userAgent={userAgent}
                ShowModal={ShowModal}
                setShowModal={setShowModal}
                setSelectedTag={setSelectedTag}
                setAddressTagList={setAddressTagList}
                saveAddress={() => createAddress.submit()}
                setTagsList={setTagsList}
              />
            </Col>
          ) : null}
        </Row>
      </Col>
    </Col>
  );
}
